(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purelle-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('purelle-header')) {
    class PurelleHeader extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.dialog = this.querySelector('[data-purelle-menu]');
        this.openButton = this.querySelector('[data-purelle-menu-open]');
        this.closeButton = this.querySelector('[data-purelle-menu-close]');
        this.lastScrollY = Math.max(0, window.scrollY);
        this.scrollFrame = 0;

        this.openButton?.addEventListener('click', () => this.openMenu(), { signal: this.signal });
        this.closeButton?.addEventListener('click', () => this.closeMenu(), { signal: this.signal });

        this.dialog?.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.closeMenu();
        }, { signal: this.signal });

        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeMenu();
        }, { signal: this.signal });

        this.dialog?.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', () => this.closeMenu(), { signal: this.signal });
        });

        window.addEventListener('scroll', () => this.requestScrollUpdate(), {
          passive: true,
          signal: this.signal
        });

        this.updateScrollState();
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        if (this.dialog?.open) this.dialog.close();
      }

      openMenu() {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        this.openButton?.setAttribute('aria-expanded', 'true');
        this.closeButton?.focus({ preventScroll: true });
      }

      closeMenu() {
        if (!this.dialog?.open) return;
        this.dialog.close();
        this.openButton?.setAttribute('aria-expanded', 'false');
        this.openButton?.focus({ preventScroll: true });
      }

      requestScrollUpdate() {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.updateScrollState();
          this.scrollFrame = 0;
        });
      }

      updateScrollState() {
        const currentScrollY = Math.max(0, window.scrollY);
        const delta = currentScrollY - this.lastScrollY;
        const mode = this.dataset.stickyMode;

        this.classList.toggle('is-scrolled', currentScrollY > 12);

        if (mode === 'scroll-up' && !this.dialog?.open) {
          if (currentScrollY > 120 && delta > 4) this.classList.add('is-hidden');
          if (delta < -3 || currentScrollY < 20) this.classList.remove('is-hidden');
        } else {
          this.classList.remove('is-hidden');
        }

        this.lastScrollY = currentScrollY;
      }
    }

    customElements.define('purelle-header', PurelleHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
